// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__19Rnm","left":"styles_left__1syyn"};